import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Period, StatsBreakdown, StatsRange } from '../../enums/reports';
import {
    initialStatsFiltersFromPeriod,
    periodFromSearchParam,
    statsRangeToStatsBreakdown,
} from './dashboardPeriod';

export function useDashboardReportFilters(
    fallbackPeriod: Period = Period.CurrentYear,
) {
    const [searchParams] = useSearchParams();
    const period = periodFromSearchParam(
        searchParams.get('period'),
        fallbackPeriod,
    );
    const initialFilters = initialStatsFiltersFromPeriod(period);

    const [range, setRangeState] = React.useState<StatsRange>(
        initialFilters.range,
    );
    const [breakdown, setBreakdown] = React.useState<StatsBreakdown>(
        initialFilters.breakdown,
    );

    const setRange = React.useCallback((newRange: StatsRange) => {
        setRangeState(newRange);
        setBreakdown(statsRangeToStatsBreakdown(newRange));
    }, []);

    return { range, breakdown, setRange, setBreakdown: setBreakdown };
}
